/* eslint-disable @wyz/module/no-relative-import */
import { Flex, Nav, Navbar } from '@wyz/ui';
import { isNil } from 'lodash-es';
import { Fragment, useEffect } from 'react';
import { useTheme } from '~/common/context';
import NavbarVerticalMenu from './navbar-vertical-menu';
import routes from '~/common/menu';
import ToggleButton from './toggle-button';

const Sidebar = () => {
  const { isNavbarVerticalCollapsed, showBurgerMenu, navbarBreakPoint } =
    useTheme();

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add('navbar-vertical-collapsed');
    } else {
      HTMLClassList.remove('navbar-vertical-collapsed');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time: ReturnType<typeof setTimeout> | null = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      // eslint-disable-next-line react-hooks/immutability
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    if (!isNil(time)) clearTimeout(time);
    HTMLClassList.remove('navbar-vertical-collapsed-hover');
  };

  return (
    <Navbar
      expand={navbarBreakPoint}
      className='navbar-vertical navbar-inverted'
      variant='light'
    >
      <Flex className='fixed-navbar' alignItems='center'>
        <ToggleButton />
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className='navbar-vertical-content scrollbar'>
          <Nav className='flex-column' as='ul'>
            {routes.map((route) => (
              <Fragment key={route.label}>
                {route.children && (
                  <NavbarVerticalMenu routes={route.children} />
                )}
              </Fragment>
            ))}
          </Nav>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Sidebar;
